export default __webpack_public_path__ + "static/smartnewsOffice-c37fca02feae67fc377afb09795a7763.png";